<template>
  <div>

    <p v-if="!ready">{{ $t('message.loading') }}</p>

    <template v-if="ready">
      <section class="col-12 no-padding">
        <section-header :title="$t('message.channelline')"/>
        <div class="col-md-12 no-padding no-margin row">
          <div class="col-md-12 col-lg-4 no-padding">
            <div
              v-for="(item, index) in filterLineList"
              :key="index"
              class="col-md-12 card">
              <section-title
                :title="item.title"
                fontweight="bold"/>
              <div class="col-md-12 no-padding no-margin row">
                <div class="col-md-12 mb-2 no-padding">
                  <div class="flex flex-column">
                    <p class="m-0">
                      {{ $t('message.notifications') }}:
                      <span v-if="filterCodeList(item.code).length == 0">-</span>
                    </p>
                    <div
                      v-for="(val, idx) in filterCodeList(item.code)"
                      :key="idx">
                      {{ $t('notificationcode.' + val) }}
                    </div>
                  </div>
                  <hr class="p-0 my-2">
                  <p class="status">
                    <span style="float: left;">
                      {{ $t('message.status') }}:
                    </span>
                    <vs-tooltip
                      :text="getActiveStatus(item.active_ids) ? $t('message.turnonnotification') : $t('message.turoffnnotification')"
                      position="top"
                      style="float: left;margin-left: 5px;">
                      <i
                        :class="getActiveStatus(item.active_ids) ? 'text-success' : 'text-danger'"
                        class="fas fa-circle"/>
                    </vs-tooltip>
                  </p>
                </div>
                <div class="row m-0 action-footer">
                  <div class="col-6 pl-0 left">
                    <button
                      type="button"
                      class="btn btn-light btn-block"
                      @click="openEditLineModal(item)">
                      <i class="fas fa-pen"/>
                      {{ $t('button.edit') }}
                    </button>
                  </div>
                  <div class="col-6 pr-0 right">
                    <button
                      type="button"
                      class="btn btn-light btn-block"
                      @click="openDeleteLineModal(item)">
                      <i class="fas fa-trash"/>
                      {{ $t('button.delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 card">
              <section-title
                :title="$t('message.getnotificationsvialine')"
                fontweight="bold"/>
              <div class="col-md-12 no-padding no-margin row">
                <div class="col-md-12 mb-2 no-padding">
                  <p>{{ $t('message.getlinenotiwith3step') }}</p>
                  <p>{{ $t('message.getlinenotistep1') }}</p>
                  <p>{{ $t('message.getlinenotistep2') }}</p>
                  <p>{{ $t('message.getlinenotistep3') }}</p>
                </div>
                <div class="col-md-12 no-padding">
                  <button
                    type="button"
                    class="btn btn-web btn-line btn-block"
                    @click="openConnectWithLineModal()">
                    <i class="fab fa-line"/>
                    {{ $t('message.getnotificationsvialine') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- <section class="col-12 no-padding">
        <section-header title="อีเมล์"></section-header>
        <div class="col-md-12 no-padding no-margin row">
          <div class="col-md-12 col-lg-4 no-padding">
            <div class="col-md-12 card">
              <section-title title="รับแจ้งเตือนผ่านทางอีเมล์" fontweight="bold"></section-title>
              <div class="col-md-12 no-padding no-margin row">
                <div class="col-md-12 mb-2 no-padding">
                  <p>มีเพียง 3 ขั้นตอน</p>
                  <p>1. เพิ่มอีเมล์</p>
                  <p>2. ยืนยันอีเมล์</p>
                  <p>3. ได้รับแจ้งเตือน</p>
                </div>
                <div class="col-md-12 no-padding">
                  <button type="button" class="btn btn-web btn-email btn-block">
                    <i class="fas fa-envelope"></i>
                    รับแจ้งเตือนผ่านทางอีเมล์
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> -->
    </template>

    <div
      id="connectWithLineModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <add-line
        v-if="show_line_add"
        :app_id="app_id"
        :code="code"
        @closed="closeConnectWithLineModal()"
        @done="handleAddLineDone()"/>
    </div>

    <div
      id="editModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <edit
        v-if="show_edit"
        :app_id="app_id"
        :code="code"
        :data="line_selected"
        @cancel="closeEditLineModal()"
        @done="handleDone()"/>
    </div>

    <div
      id="deleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <delete
        v-if="show_delete"
        :app_id="app_id"
        :data="line_selected"
        @cancel="closeDeleteLineModal()"
        @done="handleDone()"/>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import stepprogressView from '@/components/custom/StepProgress.vue'
import AddLine from '@/components/custom/modal/channelnoti/AddLine.vue'
import Edit from '@/components/custom/modal/channelnoti/Edit.vue'
import Delete from '@/components/custom/modal/channelnoti/Delete.vue'

export default {
  components: {
    stepprogressView,
    Edit,
    AddLine,
    Delete,
  },
  props: {
    app_id: {
      type: Number,
    },
    code: {
      type: Array,
    },
  },
  data () {
    return {
      ready: false,
      line_selected: null,
      show_line_add: false,
      show_edit: false,
      show_delete: false,
    }
  },
  computed: {
    ...mapGetters({
      line_list: 'getLineList',
      email_list: 'getEmailList',
    }),
    filterLineList () {
      return this.line_list
    },
  },
  watch: {
    ready: function () {
      if (this.ready) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
  },
  created: async function () {
    await this.$store.dispatch('getChannelNotis')
    // set ready
    this.ready = true
  },
  mounted: function () {
    // set popup modal
    this.setModal('#connectWithLineModal')
    this.setModal('#deleteModal')
    this.setModal('#editModal')
  },
  destroyed: function () {
    this.leavePage(this.$Progress, [])
  },
  methods: {
    filterCodeList (codeList) {
      var min = this.app_id * 100
      var max = min + 90
      return codeList.filter(val => val >= min && val <= max)
    },
    getActiveStatus (active_ids) {
      return active_ids.indexOf(this.app_id) >= 0
    },
    openConnectWithLineModal () {
      this.show_line_add = true
      $('#connectWithLineModal').modal('show')
    },
    closeConnectWithLineModal () {
      this.show_line_add = false
      $('#connectWithLineModal').modal('hide')
    },
    openEditLineModal (item) {
      this.line_selected = item
      this.show_edit = true
      $('#editModal').modal('show')
    },
    closeEditLineModal () {
      this.show_edit = false
      $('#editModal').modal('hide')
    },
    openDeleteLineModal (item) {
      this.show_delete = true
      this.line_selected = item
      $('#deleteModal').modal('show')
    },
    closeDeleteLineModal () {
      this.show_delete = false
      $('#deleteModal').modal('hide')
    },
    async handleAddLineDone () {
      // close modal
      this.closeConnectWithLineModal()
      // get new data
      this.ready = false
      await this.$store.dispatch('getChannelNotis')
      this.ready = true
    },
    async handleDone () {
      // close modal
      this.closeDeleteLineModal()
      this.closeEditLineModal()
      // get new data
      this.ready = false
      await this.$store.dispatch('getChannelNotis')
      this.ready = true
      // show notify
      this.notify(this.$vs, {
        text: this.$t('message.saved'),
        color: 'success',
        icon: 'cloud',
      })
    },
  },
}
</script>

<style scoped>
  .card {
    background: #FFF;
    border: solid 1px #D8E2E7;
    border-radius: 2px;
    padding: 15px 15px 14px 15px;
    margin: 10px 0 15px 0;
  }
  .card p {
    margin: 0 0 5px 0;
  }
  .action-footer {
    width: 100%;
  }
  .action-footer .left {
    padding-right: 7px;
  }
  .action-footer .right {
    padding-left: 7px;
  }
  .action-footer button i {
    opacity: .6;
  }
  .status i {
    font-size: 10px;
  }
  .btn-web {
    position: relative;
  }
  .btn-web i.fa-line {
    position: absolute;
    top: 7px;
    left: 7px;
    font-size: 18px;
  }
  .btn-web i.fa-envelope {
    position: absolute;
    top: 9px;
    left: 8px;
    font-size: 17px;
  }
  .stepprogress {
    position: relative;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom/ChannelNotification.vue